import React from 'react';
import PolicyPage from '../components/PolicyPage';

export default function PrivacyPolicy() {
  return <PolicyPage policy="10k-science" />;
}
